import he from "he";
import { getSeasonColor } from "../../../shared/tools";
import Deco1 from "./decorations/deco_1.js";
import Deco2 from "./decorations/deco_2.js";
import Deco3 from "./decorations/deco_3.js";
import Deco4 from "./decorations/deco_4.js";
import Deco5 from "./decorations/deco_5.js";
import Deco6 from "./decorations/deco_6.js";
import style from "./style.module.scss";

function CategoryCard({ category }) {
  const decorations = {
    1: Deco1,
    2: Deco2,
    3: Deco3,
    4: Deco4,
    5: Deco5,
    6: Deco6,
  };

  const DecoTagName = category.decoration
    ? decorations[category.decoration]
    : Deco1;

  const seasonColor = getSeasonColor();

  return (
    <a href={category.url} className={style.card}>
      <DecoTagName
        seasonColor={seasonColor}
        className={style.decoration}
        id={category.cat_ID}
      />

      <div className={style.content}>
        <p>{he.decode(category.name)}</p>
      </div>

      <div className={style.thumbnailContainer}>
        {category.thumbnail?.url && (
          <img
            className={style.thumbnail}
            src={category.thumbnail.url}
            alt={category.thumbnail.alt || category.thumbnail.title}
            loading="lazy"
          />
        )}
      </div>
    </a>
  );
}

export default CategoryCard;
